import { Button, Create, SaveButton, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import { ShootBlockingForm } from "components/forms/frm_shootblocking";
import { FC } from "react";

export const ShootBlockingCreate: FC<IResourceComponentsProps> = () => {
  const { goBack, push } = useNavigation();

  const { formProps, saveButtonProps, queryResult } = useForm({
    resource: "v1/bot-integration/prospect",
    redirect: false,
    successNotification: {
      type: "success",
      message: "Sucesso",
      description: "Operação realizada com sucesso",
    },
    onMutationSuccess: () => push("/engaging/shoot-blocking"),
  });

  return (
    <Create
      title="Incluir Bloqueio"
      footerButtons={() => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Button onClick={() => goBack()}>Cancelar</Button>

          <SaveButton {...saveButtonProps} icon={null}>
            Incluir
          </SaveButton>
        </div>
      )}
    >
      <ShootBlockingForm formProps={formProps} queryResult={queryResult} />
    </Create>
  );
};
